import { buildPortfolioContext } from './portfolioContextBuilder';
import { buildTransactionContext } from './transactionContextBuilder';
import { buildValuationContext } from './valuationContextBuilder';

export interface ContextBuildResult {
  portfolioContext: string;
  transactionContext: string;
  valuationContext: string;
}

export const buildFullContext = async (): Promise<ContextBuildResult> => {
  const [portfolioResult, transactionResult, valuationResult] = await Promise.allSettled([
    buildPortfolioContext(),
    buildTransactionContext(),
    buildValuationContext(),
  ]);

  return {
    portfolioContext:
      portfolioResult.status === 'fulfilled' ? portfolioResult.value : 'Portfolio data temporarily unavailable.',
    transactionContext:
      transactionResult.status === 'fulfilled'
        ? transactionResult.value
        : 'Transaction history temporarily unavailable.',
    valuationContext:
      valuationResult.status === 'fulfilled' ? valuationResult.value : 'Valuation history temporarily unavailable.',
  };
};
